var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeaderBoard = function SvgLeaderBoard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00CC5D",
    d: "m9.79 14.913 2.025-1.065a.4.4 0 0 1 .37 0l2.025 1.065a.398.398 0 0 0 .578-.42l-.387-2.255a.4.4 0 0 1 .115-.352l1.638-1.598a.398.398 0 0 0-.22-.678l-2.265-.33a.4.4 0 0 1-.3-.217L12.358 7.01a.398.398 0 0 0-.714 0L10.63 9.063a.4.4 0 0 1-.3.218l-2.263.329a.398.398 0 0 0-.221.678l1.638 1.598a.4.4 0 0 1 .115.352l-.387 2.255a.398.398 0 0 0 .578.42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.5,
    d: "M4.092 5.056a2 2 0 0 1 2-2h11.862a2 2 0 0 1 2 2v13.999c0 1.574-1.735 2.531-3.067 1.691l-3.797-2.394a2 2 0 0 0-2.133 0l-3.798 2.394c-1.332.84-3.067-.117-3.067-1.691z"
  })));
};
export default SvgLeaderBoard;